export default __webpack_public_path__ + "static/media/projeto1.e938dc17.PNG";